import axios from "axios";

axios.defaults.withCredentials = true;

export async function addToCartItems(item) {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/cart/`, item);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function fetchCartItemsByUserId() {
    try {
        //This will fetch the product based on token payload in httpOnly Cookie
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/cart/`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function updateCartItemsByUserId(updateData) {
    try {
        const { id, ...dataToUpdate } = updateData;
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/cart/${id}`, dataToUpdate);
        return response.data
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function removeCartItemsByUserId(cartId) {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/cart/${cartId}`);
        return response.data
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}
